module.exports = __webpack_public_path__ + "img/squid_1.10e2905e.svg";